import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { publicOverrides, absoluteUrl } from "../lib/api";
import { imageForSub } from "../lib/serviceImages";

const OverridesContext = createContext({ overrides: {}, refresh: () => {} });

export function OverridesProvider({ children }) {
  const [overrides, setOverrides] = useState({});

  const refresh = useCallback(async () => {
    try {
      const data = await publicOverrides();
      setOverrides(data.overrides || {});
    } catch (_e) {
      /* keep prior */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ overrides, refresh }), [overrides, refresh]);
  return <OverridesContext.Provider value={value}>{children}</OverridesContext.Provider>;
}

export function useOverrides() {
  return useContext(OverridesContext);
}

// Given a service catalog sub, merge in any admin-published overrides + default imagery.
export function applySubOverride(sub, overrides) {
  const next = { ...sub };
  // Attach a default editorial image per sub (only if the card is not a logo card).
  if (next.cardType !== "logos" && !next.image) {
    const img = imageForSub(next.code);
    if (img) next.image = img;
  }
  const o = overrides?.[sub.code];
  if (o) {
    if (o.price) next.price = o.price;
    if (o.image) next.image = absoluteUrl(o.image);
  }
  return next;
}
